import { IBaseEntity, IBaseQuery } from './common.type';

export interface IPackage extends IBaseEntity {
  quantity: number;
  type: EPackageType;
  receiver: number;
  micro: number;
  integration: number;
}

export enum EPackageType {
  d = 'd',
  m = 'm',
  y = 'y',
  i = 'i',
}

export interface IPackageBody {
  quantity: number;
  type: EPackageType;
  receiver: number;
  micro: number;
  integration: number;
}

export interface IPackageQuery extends IBaseQuery {}
